/**
 * Regras de cobrança que o checkout espelha do pay — o pay é quem decide na
 * compra; aqui é só para o comprador ver o erro ANTES de tentar pagar.
 */
import { PaymentGateway } from '../api/applications/types/applications.types';

/** Menor valor cobrado numa venda com cupom (`curseduca-pay` · `charge-floor.ts`). */
export const MIN_CHARGE = 5;

/** Taxa de juros de parcelamento quando a plataforma não informa a dela. */
export const DEFAULT_INSTALLMENT_RATE = 0.0299;

const toCents = (value: number) => Math.round(Number(value) * 100);

/**
 * O cupom deixa uma cobrança maior que zero e menor que o piso?
 * Zerar a compra é permitido (caminho gratuito). Só vale no Waid Pay v2
 * (gateway MALGA), igual ao pay — nos demais gateways nada muda.
 */
export const couponBreaksChargeFloor = (input: {
	price?: number | null;
	discount?: number | null;
	gateway?: PaymentGateway | null;
}): boolean => {
	if (input.gateway !== 'MALGA') return false;

	const price = toCents(input.price ?? NaN);
	const discount = toCents(input.discount ?? 0);
	if (!Number.isFinite(price) || !Number.isFinite(discount)) return false;
	if (discount <= 0) return false;

	const charge = price - discount;
	return charge > 0 && charge < toCents(MIN_CHARGE);
};

/**
 * Taxa de juros para `count` parcelas: a da plataforma
 * (`/applications/params` → `installmentRates`) ou 2,99% quando ela não vem.
 */
export const installmentRateFor = (
	installmentRates: Record<number, number> | null | undefined,
	count: number
): number => {
	const rate = installmentRates?.[count];
	return typeof rate === 'number' && rate >= 0
		? rate
		: DEFAULT_INSTALLMENT_RATE;
};
